import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import './Page404.css'

const Page404 = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate('/', { replace: true })
    }
  }

  return (
    <div className="page-404">
      <PublicAppHeader
        config={{ showLinks: false, showBackButton: true }}
        backButtonFunction={handleGoBack}
      />

      <div className="error-container">
        <div className="error-content">
          <div className="error-svg">
            <img src={'/page_not_found.svg'} alt="404Illustration" style={{ width: '250px' }} />
          </div>
          <h1 className="error-title">404 - Page Not Found</h1>
          <p className="error-message">Oops! Looks like you{"'"}re lost.</p>
          <p className="error-message">The page you are looking for does not exist or may have been moved.</p>
          <p className="error-message">Please check the URL or go back to :</p>
          <div className="error-actions">
            <button type="button" onClick={handleGoBack} className="btn btn-primary btn-sm">
              Go Back
            </button>
            <Link to="/" className="btn btn-primary btn-sm">
              Go Home
            </Link>
            <Link to="/reset-storage" className="btn btn-primary btn-sm">
              Reset Application
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page404